goog.provide('el8.appchart.refpanel.demog');

goog.require('el8.data.practiceSettings');
goog.require('el8.appchart.dialog.eligibilities');
goog.require('el8.appshared.dialog.editPatient');
goog.require('el8.appshared.dialog.inviteToPassport');
goog.require('el8.appshared.eligibility');
goog.require('el8.ptdata.eligibilities');
goog.require('el8.ptdata.hccScoreDetails');
goog.require('el8.uiwidget.confirm');

el8.appchart.refpanel.demog = (function() {

    var that = new el8.uiwidget.Component({
        initFn: function() {
            $(document).on('click', '.eligibilities_trigger',  function(event) {
                event.preventDefault();
                var submitRequest = false;
                el8.appchart.dialog.eligibilities.show(submitRequest);
            });
            $('#refBoard').on('click', '.passport-invite-trigger',  function() {
                el8.appshared.dialog.inviteToPassport.show();
            });

            var primaryProviderUserId = el8.ptdata.currPatient.getPrimaryPhysicianUserId();
            var curProvider = el8.data.practiceUsers.getById(primaryProviderUserId);
            if (!curProvider.isActive()) {
                var confirmMsg = "This patient is currently assigned to an inactive physician ("
                    + curProvider.getFullName() + "). Would you like to update the patient's primary provider?";
                el8.uiwidget.confirm(confirmMsg, function() {
                    el8.appshared.dialog.editPatient.show();
                });
            }
        }
    });

    that.triggerRender = function() {
        el8React.messenger.send('PatientProfileRefresh');
    };

    return that;

})();
